module.exports = __webpack_public_path__ + "static/3-f54c6e75e5975fc2e4b311e861cc3fdf.jpg";